module.exports = __webpack_public_path__ + "static/media/wingate_collection05_26_1140.6f715383.jpg";